'use client';

import { useEffect } from 'react';
import type { JobDetail } from '~/types/job-detail';
import { FixedScrollTop } from '../footer/fixed-scroll-top';
import { ApplicationButton } from '~/components/button/application-button';
import { FavoriteButton } from '~/components/button/job-detail-favorite-button';
import Image from 'next/image';

type Props = {
  job: JobDetail;
  isSignedIn: boolean;
  jobApplicantsJobIds: number[];
  isFavorite: boolean;
  isMobile: boolean;
  favoriteJobIds: number[];
};

export default function JobDetailsFloatingButtons({
  job,
  isSignedIn,
  jobApplicantsJobIds,
  isFavorite,
  isMobile,
  favoriteJobIds,
}: Props) {
  const hasApplied = jobApplicantsJobIds.includes(job.id);

  // ------------------------------
  // jQuery フローティング制御組み込み
  // ------------------------------
  useEffect(() => {
    const setupFloatingMenu = async () => {
      const jQuery = await import('jquery');
      const $: any = jQuery.default;

      class JobDetailFloatingMenu {
        isFloatingMenuHidden = false;
        showThreshold: number;

        constructor(showThreshold: number) {
          this.showThreshold = showThreshold;
          this.bindEvents();
          this.scrollEvent();
        }

        scrollEvent() {
          $(window).on('scroll', () => {
            if (this.isSlideFormVisible()) {
              $('.c-floating-menu__js, .js-back-to-top').fadeOut(100);
            } else if (
              ($(window as any).scrollTop() ?? 0) >= this.showThreshold &&
              !this.isFloatingMenuHidden
            ) {
              $('.c-floating-menu__js, .js-back-to-top').fadeIn(100);
            } else {
              $('.c-floating-menu__js, .js-back-to-top').fadeOut(100);
            }
          });
        }

        bindEvents() {
          $('.js-back-to-top').on('click', () => {
            $('body, html').animate({ scrollTop: 0 }, 500);
          });

          $('.c-floating-menu__apply .btn-close').on('click', () => {
            $('.c-floating-menu__js').hide();
            this.isFloatingMenuHidden = true;
          });
        }

        isSlideFormVisible() {
          const slideForm = document.querySelector(
            '#horizontal_slide_form_wrapper',
          );
          if (!slideForm) return false;

          const rect = slideForm.getBoundingClientRect();
          const slideFormTop = rect.top;
          const slideFormBottom = rect.bottom;

          return slideFormBottom > 0 && slideFormTop <= window.innerHeight;
        }
      }

      new JobDetailFloatingMenu(300);
    };

    setupFloatingMenu();
  }, []);

  const serviceType = job.service_type === '求人広告' ? 'ad' : 'agent';

  // ------------------------------
  // JSX
  // ------------------------------
  return (
    <div className="c-floating-menu__js" style={{ display: 'none' }}>
      <div className="c-floating-menu__apply">
        <button type="button" className="btn-close absolute top-2 right-2">
          <Image
            alt="閉じるアイコン"
            src="/nextjs/images/icons/btn_white_close.png"
            width={18}
            height={18}
          />
        </button>

        <div
          className={
            isSignedIn
              ? 'c-floating-menu__apply__buttons -w-full-m0'
              : 'u-mt0 u-mb0 p-job-detail__buttons'
          }
        >
          <FavoriteButton
            jobId={job.id}
            isFavorite={isFavorite}
            isSignedIn={isSignedIn}
            isMobile={isMobile}
            favoriteJobIds={favoriteJobIds}
            className={isSignedIn ? '' : 'u-py10'}
          />
          <ApplicationButton
            job={job}
            isMobile={isMobile}
            isApplied={hasApplied}
            isSignedIn={isSignedIn}
            serviceType={serviceType}
            position="floating"
          />
        </div>
      </div>
      <FixedScrollTop />
    </div>
  );
}
